/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* A Vikimap service module to use for a Vikimap driven application. Supports Accedo One, JSON and Middleware services. (@accedo/vdkweb-vikimap) 4.0.8
* 
*******************************************************************************/
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reduce = _interopRequireDefault(require("lodash/reduce"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/* eslint-disable prefer-promise-reject-errors, no-throw-literal */
var MAX_SIZE = 50;
var mapEntry = function mapEntry(entry) {
  return _objectSpread(_objectSpread({}, entry), {}, {
    id: entry._meta.id,
    alias: entry._meta.entryAlias
  });
};
var mapEntries = function mapEntries(entries) {
  return entries.entries.map(mapEntry);
};
var omit = function omit(obj) {
  var keys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  if (!obj || !keys || !keys.length) {
    return obj;
  }
  var newObj = _objectSpread({}, obj);
  keys.forEach(function (k) {
    delete newObj[k];
  });
  return newObj;
};

// A convenience method for following paginated responses
// and request more pages in a paginated sequence.
var followPagination = function followPagination(paginationCall) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? MAX_SIZE : _ref$size,
    _ref$offset = _ref.offset,
    offset = _ref$offset === void 0 ? 0 : _ref$offset,
    _ref$pageLimit = _ref.pageLimit,
    pageLimit = _ref$pageLimit === void 0 ? 0 : _ref$pageLimit;
  return paginationCall({
    offset: offset,
    size: size
  }).then(function (entries) {
    if (!entries || !entries.pagination || !entries.pagination.total) {
      return Promise.resolve(entries);
    }

    // Find out the total amount of entries and calculate
    // the number of requests we have to perform to get them.
    var total = entries.pagination.total;
    var remaining = total - size;
    var nrOfRemainingRequests = Math.ceil(remaining / size);
    var nrOfRequests = pageLimit > 0 ? Math.min(pageLimit - 1, nrOfRemainingRequests) : nrOfRemainingRequests;
    var promises = [];

    // Collect all request promises
    for (var i = 1; i <= nrOfRequests; i += 1) {
      promises.push(paginationCall({
        offset: i,
        size: size
      }));
    }
    return Promise.all(promises).then(function (results) {
      // Concatenate all entries from all reqeusts into one list
      var allEntries = (0, _reduce["default"])(results, function (all, newEntries) {
        return all.concat(newEntries.entries);
      }, entries.entries);
      return {
        entries: allEntries
      };
    });
  });
};
var AccedoOneEntryProvider = /*#__PURE__*/function () {
  function AccedoOneEntryProvider(accedoOneClient) {
    _classCallCheck(this, AccedoOneEntryProvider);
    this.client = accedoOneClient;
  }

  /**
   * Retrieves an entry from Accedo One by ID.
   *
   * @param  {string} id          The ID for the entry to fetch
   * @param  {object} [options]   Custom options params to be passed to the Accedo One client
   * @return {Promise}            A promise resolving with the entry
   */
  _createClass(AccedoOneEntryProvider, [{
    key: "getEntryById",
    value: function getEntryById(id, options) {
      if (!this.client) {
        return Promise.reject('The Accedo One client has not been initialized properly. Call init(options) to set it.');
      }
      return this.client.getEntryById(id, options).then(mapEntry)["catch"](function (error) {
        throw {
          id: id,
          error: error
        };
      });
    }

    /**
     * Retrieves a list of entries from Accedo One by an array
     * of IDS.
     *
     * @param  {array} ids          An array of IDs for the entries to fetch
     * @param  {object} [options]   Custom options params to be passed to the Accedo One client
     * @return {Promise}            A promise resolving with the list of entries
     */
  }, {
    key: "getEntriesByIds",
    value: function getEntriesByIds(ids, options) {
      if (!ids || !ids.length) {
        return Promise.resolve([]);
      }
      return this.getAllEntries(_objectSpread(_objectSpread({}, options), {}, {
        id: ids
      }))["catch"](function (error) {
        throw {
          ids: ids,
          error: error
        };
      });
    }

    /**
     * Retrieves an entry from Accedo One by alias.
     *
     * @param  {string} alias       The alias for the entry to fetch
     * @param  {object} [options]   Custom options params to be passed to the Accedo One client
     * @return {Promise}            A promise resolving with the entry
     */
  }, {
    key: "getEntryByAlias",
    value: function getEntryByAlias(alias, options) {
      if (!this.client) {
        return Promise.reject('The Accedo One client has not been initialized properly. Call init(options) to set it.');
      }
      return this.client.getEntryByAlias(alias, options).then(mapEntry)["catch"](function (error) {
        throw {
          alias: alias,
          error: error
        };
      });
    }

    /**
     * Retrieves a list of entries from Accedo One by an array
     * of aliases.
     *
     * @param  {array} aliases      An array of aliases for the entries to fetch
     * @param  {object} [options]   Custom options params to be passed to the Accedo One client
     * @return {Promise}            A promise resolving with the list of entries
     */
  }, {
    key: "getEntriesByAliases",
    value: function getEntriesByAliases(aliases, options) {
      if (!aliases || !aliases.length) {
        return Promise.resolve([]);
      }
      return this.getAllEntries(_objectSpread(_objectSpread({}, options), {}, {
        alias: aliases
      }))["catch"](function (error) {
        throw {
          aliases: aliases,
          error: error
        };
      });
    }

    /**
     * Returns all entries available.
     *
     * Requests entries in chunks from Accedo One since Accedo One has
     * a limitation of only returning 50 entries at the time.
     *
     * NOTE: Use with caution.
     *
     * @param {object} [options]           Options for pagination and custom values to be passed on to the Accedo One client.
     * @param {number} options.offset      The offset page number for this request
     * @param {number} options.size        The number of items to fetch in one page request
     * @param {number} options.pageLimit   The max amount of pages to fetch when following pagination results.
     * @param {*} options.{*}              Arbitrary options which will be passed to the Accedo One client
     *
     * @return {array}           List of all entries
     */
  }, {
    key: "getAllEntries",
    value: function getAllEntries(options) {
      var _this = this;
      if (!this.client) {
        return Promise.reject('The Accedo One client has not been initialized properly. Call init(options) to set it.');
      }
      var clientOptions = omit(options, ['pageLimit']);
      var paginatedCall = function paginatedCall(_ref2) {
        var offset = _ref2.offset,
          size = _ref2.size;
        return _this.client.getEntries(_objectSpread(_objectSpread({}, clientOptions), {}, {
          offset: offset,
          size: size
        }));
      };
      return followPagination(paginatedCall, options).then(mapEntries);
    }
  }]);
  return AccedoOneEntryProvider;
}();
var _default = AccedoOneEntryProvider;
/* eslint-enable prefer-promise-reject-errors, no-throw-literal */
exports["default"] = _default;